/**
 * Standalone, Keycloak-free signup app bootstrap.
 *
 * Runs in main.tsx BEFORE — and INSTEAD OF — the normal app bootstrap when the
 * current path is /signup. Same pattern as oauth-callback-standalone: the path
 * check happens before initKeycloak() so the Keycloak login-required flow never
 * triggers for this public registration page.
 *
 * Does NOT use TanStack Router — the signup page is pre-router, mounted as a
 * standalone React root. This is intentional and consistent with ADR-001 (we are
 * not adding an alternative router; we are short-circuiting bootstrap for a public
 * path, same as the OAuth callback bridge).
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SignupApp } from './SignupApp';

export const SIGNUP_PATH = '/signup';

export function runSignupApp(): void {
  const root = document.getElementById('root');
  if (!root) return;
  createRoot(root).render(
    <StrictMode>
      <SignupApp />
    </StrictMode>,
  );
}
